/**
 * Created by mateimisarca on 2019-06-07
 */

import CursuriPage from './cursuri-page';
export default CursuriPage;
